import React, { Component } from "react";
import axios from "axios";
import PresentationModal from "./PresentationModal";

import domain from ".././../../../domain";

import { Row, Col, Card, CardBody } from "mdbreact";
import { Badge } from "mdbreact";

const moment = require("moment-timezone");
// function indexN(cell, row, enumObject, index) {
//     return (<div>{index+1}</div>)
// }
function dateFormatter(cell) {
  return moment(cell).tz("Asia/Kolkata").format("DD/MM/YYYY");
}
// function timeFormatter(cell) {
//   return moment(cell,"h:mm a").format("HH:mm a")

//  }

class AddPresentationsBySessionId extends Component {
  constructor() {
    super();
    this.state = {
      sessions: [],
      course_id: "",
      course_name: "",
      status: "",
    };
  }

  componentDidMount() {
    this.getSessions();
    this.getCourse();
  }

  async getCourse() {
    let courseId = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${courseId}`);
    this.setState({
      course_name: result.data[0].title,
      status: result.data[0].status,
    });
  }

  getSessions() {
    let courseId = this.props.match.params.id;
    axios
      .get(`${domain.DBServer}/fetch-sessions/${courseId}`)
      .then((response) => {
        console.log(response.data);
        this.setState(
          { sessions: response.data, course_id: response.data[0].course_id },
          () => {}
        );
      })
      .catch((err) => console.log(err));
  }

  render() {
    let sessions;
    if (this.state.sessions != null) {
      sessions = this.state.sessions.map((session, key) => {
        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th scope="row" style={{ textAlign: "right" }}>
              {key + 1}
            </th>
            <td>{session.lecturer_name}</td>
            <td>{session.title}</td>
            <td>{dateFormatter(session.session_date)}</td>

            <td>{session.start_time}</td>
            <td>{session.end_time}</td>
            <td>
              {session.presentation ? (
                <div>
                  <Badge>Presentation available</Badge>
                  <PresentationModal session={session} />
                </div>
              ) : (
                <div>
                  <PresentationModal session={session} />
                </div>
              )}
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        <Row>
          <Col md="12">
            <Card>
              <CardBody>
                <h3 style={{ textAlign: "center", color: "blue" }}>
                  {this.state.course_name}
                </h3>
                <h4 style={{ textAlign: "center", color: "blue" }}>
                  List of Sessions
                </h4>
                <table
                  className="table table-striped table-bordered table-responsive-md"
                  cellSpacing="0"
                  width="100%"
                >
                  <thead
                    style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                  >
                    <tr>
                      <th scope="col" width="20">
                        Lecture No
                      </th>
                      <th scope="col" width="50">
                        Lecturer Name
                      </th>
                      <th scope="col" width="100">
                        Title of the Session
                      </th>
                      <th scope="col" width="100">
                        Date{" "}
                      </th>
                      <th scope="col" width="50">
                        Start Time
                      </th>
                      <th scope="col" width="50">
                        End Date
                      </th>
                      <th scope="col" width="50">
                        Upload Presentation
                      </th>
                    </tr>
                  </thead>
                  <tbody>{sessions}</tbody>
                </table>

                <div></div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default AddPresentationsBySessionId;
